import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=58e37f19&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=58e37f19&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e37f19",
  null
  
)

export default component.exports